import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

export type Platform = 'web' | 'ios' | 'android';

export interface PlatformInfo {
  platform: Platform;
  isNative: boolean;
  isWeb: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  isMobile: boolean;
}

export function usePlatform(): PlatformInfo {
  const [platformInfo, setPlatformInfo] = useState<PlatformInfo>(() => {
    const platform = Capacitor.getPlatform() as Platform;
    const isNative = Capacitor.isNativePlatform();
    const isWeb = platform === 'web';
    const isIOS = platform === 'ios';
    const isAndroid = platform === 'android';
    const isMobile = isIOS || isAndroid;

    return {
      platform,
      isNative,
      isWeb,
      isIOS,
      isAndroid,
      isMobile,
    };
  });

  useEffect(() => {
    const platform = Capacitor.getPlatform() as Platform;
    const isNative = Capacitor.isNativePlatform();
    const isWeb = platform === 'web';
    const isIOS = platform === 'ios';
    const isAndroid = platform === 'android';
    const isMobile = isIOS || isAndroid;

    setPlatformInfo({
      platform,
      isNative,
      isWeb,
      isIOS,
      isAndroid,
      isMobile,
    });
  }, []);

  return platformInfo;
}
